/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(complaintId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetCorrespondencesByComplaint: {
        $xmlns: 'http://dobs.pa.gov/cs/correspondence/bpm/1.0',
        ComplaintID: complaintId
      }
    },
    blueprintArrays: ['GetCorrespondencesByComplaintResponse.Correspondences.CS_Correspondence'],
    blueprint: {
      correspondences: [
        '$..CS_Correspondence',
        {
          correspondenceId: '$..ID',
          complaintId: '$..ComplaintID',
          statusId: '$..StatusID',
          status: '$..Status',
          requestedByName: '$..RequestedByName',
          complainantName: '$..ComplainantName',
          createdDate: '$..CreatedDate',
          requestedOn: '$..RequestedOn',
          recipientTypeId: '$..RecipientTypeID'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.correspondences, function(correspondence) {
        correspondence.status = correspondence.status || '--';
        correspondence.requestedByName = correspondence.requestedByName || '--';
        correspondence.complainantName = correspondence.complainantName || '--';
      });
      deferred.resolve(response.correspondences);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
